import Vue from "vue";

/**
 * Globaler Event Bus für Component-übergreifende Kommunikation
 * Verwendet für Badge-Updates nach Interaktionen
 */
export const EventBus = new Vue();

// Event-Namen als Konstanten
export const EVENTS = {
    // Wird nach jeder User-Interaktion gefeuert
    INTERACTION_COMPLETED: "interaction:completed",
    // Wird gefeuert wenn Badge neu geladen werden soll
    BADGE_REFRESH: "badge:refresh"
};
